import React, { Component } from "react";
import {Card, DatePicker, message, Modal, Select, Popconfirm} from 'antd'
import {map, isEmpty, orderBy} from 'lodash';
import {PlusCircleOutlined, CloseCircleOutlined} from '@ant-design/icons';
import moment from "moment-timezone";

import Loader from "../../../../Common/Component/Loader";
import PreviewMap from "./PreviewMap";
import * as yup from "yup";

const {Option} = Select;

class Kanban extends Component {
  constructor(props) {
    super(props);
    this.state = {
      main_card: [
        {title: "Proposal Signed", status: 'proposal_signed', data: []},
        {title: "Miss Utility", status: 'miss_utility', data: []},
        {title: "Schedule for Installation", status: 'scheduled', data: []},
        {title: "Current", status: 'current', data: []},
        {title: "Completed", status: 'completed', data: []}
      ],
      loader: false,
      list: [],
      showMap: false,
      markers: [],
      errors: []
    }
  }

  componentDidMount = () => {
    this.setState({loader: true})
    this.props.getCommercialProposal(); // get kanban list
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    // message.destroy()
    this.setState({loader: false});
    // get service order
    if (Object.keys(nextProps?.CommercialProposal?.getCommercialProposal).length > 0
      && JSON.stringify(nextProps?.CommercialProposal?.getCommercialProposal) !== JSON.stringify(this.props?.CommercialUsers?.getCommercialProposal)) {
      this.filterCards(nextProps?.CommercialProposal?.getCommercialProposal?.results)
    }

    // get filter conditions
    if (Object.keys(nextProps?.filterData).length > 0 && JSON.stringify(nextProps?.filterData) !== JSON.stringify(this.state.filterData)) {
      this.setState({filterData: nextProps?.filterData}, () => this.onFilter());
    }
  }

  // on customer filter
  onFilter = () => {
    const {filterData} = this.state;
    this.setState({loader: true})
    const obj = {};

    (filterData?.franchise && filterData?.franchise !== 'all') &&
    Object.assign(obj, {commercial_quote__field_office__uuid: filterData?.franchise});
    this.props.getCommercialProposal(obj); // get kanban list
  }


  filterCards = (results) => {
    const {main_card} = this.state;
    let signed = [], utility = [], schedule = [], current = [], completed = [];
    map(results, (obj) => {
      obj.pws_installations = orderBy(obj?.pws_installations, 'created_at', 'asc')
      const status = obj?.pws_installations?.[0]?.status;
      if (status === 'proposal_signed' || obj?.pws_installations?.length === 0) {
        signed.push(obj)
      } else if (status === 'miss_utility') {
        utility.push(obj)
      } else if (status === 'scheduled') {
        schedule.push(obj)
      } else if (status === 'current') {
        current.push(obj)
      } else if (status === 'completed') {
        completed.push(obj)
      }
    })
    main_card[0]['data'] = signed;
    main_card[1]['data'] = utility;
    main_card[2]['data'] = schedule;
    main_card[3]['data'] = current;
    main_card[4]['data'] = completed;
    this.setState({main_card})
  }

  // toggle Map
  toggleMap = () => {
    this.setState((prevState) => ({showMap: !prevState.showMap}))
  }

  // on add date
  onAddDate = (card, index) => {
    const {main_card} = this.state
    const card_idx = main_card.findIndex(obj => obj.title === card.title)
    const proposal_data = main_card[card_idx]['data'][index];
    proposal_data.pws_installations.push({
      number_of_pws_stations: [],
      start_date: '',
      end_date: ''
    })
    this.setState({main_card})
  }

  // on Remove
  onRemove = (card, inner_card, index) => {
    const {main_card} = this.state
    const card_idx = main_card.findIndex(obj => obj.title === card.title)
    const inner_card_idx = main_card[card_idx]['data'].findIndex(obj => obj.uuid === inner_card.uuid);
    main_card[card_idx]['data'][inner_card_idx].pws_installations.splice(index, 1)
    this.setState({main_card})
  }

  // on PWS station changed
  onPWSStationChanged = (card, obj, pws_index, key, e) => {
    const { main_card } = this.state
    const card_idx = main_card.findIndex(obj => obj.title === card.title)
    const proposal_idx = main_card[card_idx]['data'].findIndex((x) => x.uuid === obj.uuid);
    if (key === 'number_of_pws_stations') {
      main_card[card_idx]['data'][proposal_idx]['pws_installations'][pws_index][`${key}`] = [e]
    } else {
      main_card[card_idx]['data'][proposal_idx]['pws_installations'][pws_index][`${key}`] = e
    }
    this.setState({main_card})
  }

  // on drop cards
  onDrop = (e, destination) => {
    const {main_card} = this.state;
    let arr = [];
    const source = JSON.parse(e.dataTransfer.getData("text"))
    main_card[destination]['data'].push(main_card[source.card_index]['data'][source.inner_card_index])
    if (main_card[source.card_index]['data'][source.inner_card_index]['pws_installations']?.length > 0) {
      map(main_card[source.card_index]['data'][source.inner_card_index]['pws_installations'], (obj, index) => {
        main_card[source.card_index]['data'][source.inner_card_index]['pws_installations'][index]['status'] = main_card[destination]['status']
        arr.push(this.props.updatePWSInstall(obj?.uuid, {status: main_card[destination]['status']}))
      })
      main_card[source.card_index]['data'].splice(source.inner_card_index, 1)

      this.setState({loader: true})
      Promise.all(arr).then(() => {
        this.setState({loader: false, main_card})
      })
    } else {
      Modal.error({
        title: 'Error',
        content: 'Please add installation dates',
      });
    }
  }

  // on drag start
  onDragStart = (e, card_index, inner_card_index) => {
    e.dataTransfer.setData("text/plain", JSON.stringify({card_index, inner_card_index}))
  }

  // validate required fields
  validate = (pws_installations, proposal_uuid, card_index, inner_card_index) => {
    const {errors} = this.state;
    const schema = yup.object().shape({
      pws_installations: yup.array(yup.object().shape({
        number_of_pws_stations: yup.array(yup.string()).required('Number of PWS station is required'),
        start_date: yup.string().nullable(true).required('Start Date is required'),
        end_date: yup.string().nullable(true).required('End Date is required').test("compare", "Invalid end date", function(end_date) {
          return moment(this.parent.start_date || "").isBefore(moment(end_date || "")) } ),
      })).required('Installation dates are required')
    });

    const data = {pws_installations}

    setTimeout(() => {
      schema.validate(data, { abortEarly: false }).then(() => {
        this.setState({ is_btn_active: true, errors: [] });
        // alert('Hello')
        this.onUpdate(proposal_uuid, card_index, inner_card_index)
      }).catch((error) => {
        let err_data = {};
        map(error.inner, (item) => {err_data[item.path] = item.message})
        if (!Array.isArray(errors[card_index])) errors[card_index] = []
        errors[card_index][inner_card_index] = err_data
        this.setState({errors, is_btn_active: false})
      });
    }, 200);
  };

  // on update
  onUpdate = (proposal_uuid, card_index, inner_card_index) => {
    const {main_card} = this.state;
    const {addPWSInstall, updatePWSInstall, getCommercialProposal} = this.props;
    let arr = [];
    map(main_card[card_index]['data'][inner_card_index]['pws_installations'], (obj) => {
      if (obj?.uuid) {
        arr.push(updatePWSInstall(obj.uuid, {number_of_pws_stations: obj.number_of_pws_stations,
          start_date: obj.start_date ? moment(obj?.start_date?.toUTCString()).format('YYYY-MM-DD') : null,
          end_date: obj.end_date ? moment(obj?.end_date?.toUTCString()).format('YYYY-MM-DD') : null, proposal_uuid: obj.proposal_uuid}))
      }
      else {
        arr.push(addPWSInstall({number_of_pws_stations: obj.number_of_pws_stations,
          start_date: obj.start_date ? moment(obj?.start_date?.toUTCString()).format('YYYY-MM-DD') : null,
          end_date: obj.end_date ? moment(obj?.end_date?.toUTCString()).format('YYYY-MM-DD') : null, proposal_uuid}))
      }
    })

    this.setState({loader: true})
    Promise.all(arr).then((response) => {
      if (!isEmpty(response)) {
        getCommercialProposal()
      }
    })
  }

  // render PWS installation cards
  renderInstallation = (card, card_index, inner_card, inner_card_index, pws, pws_index) => {
    const {errors} = this.state;
    const max_count = 6;
    let included_stations = [], stations = [];
    map(inner_card?.pws_installations, x => {
      if (Array.isArray(x.number_of_pws_stations)) {
        included_stations.push(...x.number_of_pws_stations)
      } else {
        included_stations.push(x.number_of_pws_stations)
      }
    })
    for (let i = 0; i < max_count; i++) {
      if (!included_stations?.includes(i + 1)) stations.push(<Option value={i + 1} key={`Option${i}`}>{i + 1}</Option>)
    }

    return (
      <div key={`PWS${pws_index}`}>
        <div className="form-group">
          <div className="fitem">
            <div className="card-title flex">
              <label>PWS Stations</label>
              <Popconfirm
                title="Are you sure?"
                onConfirm={() => this.onRemove(card, inner_card, pws_index)}
                okText="Yes"
                cancelText="No"
              >
                <CloseCircleOutlined/>
              </Popconfirm>
            </div>
            <Select
              name='number_of_pws_stations'
              placeholder="Please Select"
              // mode="multiple"
              showArrow
              // showSearch
              // virtual={false}
              style={{ width: '100%' }}
              value={pws?.number_of_pws_stations ? pws?.number_of_pws_stations?.[0] : null}
              onChange={(e) => this.onPWSStationChanged(card, inner_card, pws_index, 'number_of_pws_stations', e)}
            >
              {stations}
            </Select>
            {errors?.[card_index]?.[inner_card_index]?.[`pws_installations[${pws_index}].number_of_pws_stations`] ? <label className="new_err_msg">
              <i className="las la-info-circle"/>{errors?.[card_index]?.[inner_card_index]?.[`pws_installations[${pws_index}].number_of_pws_stations`]}</label> : ''}
          </div>
        </div>
        <div className="fitem">
          <div className="form-group">
            <div className="fitem half-fitem">
              <div className="fitem half-fitem">
                <label>Start</label>
                <DatePicker
                  name='start_date'
                  inputReadOnly
                  placeholder={'Start'}
                  format={"MMM DD YYYY"}
                  value={pws.start_date ? moment((new Date(pws.start_date)).toString()) : null}
                  onChange={(e) => this.onPWSStationChanged(card, inner_card, pws_index, 'start_date', e)}
                />
                {errors?.[card_index]?.[inner_card_index]?.[`pws_installations[${pws_index}].start_date`] ? <label className="new_err_msg">
                  <i className="las la-info-circle"/>{errors?.[card_index]?.[inner_card_index]?.[`pws_installations[${pws_index}].start_date`]}</label> : ''}
              </div>
              <div className="fitem half-fitem">
                <label>End</label>
                <DatePicker
                  name='end_date'
                  inputReadOnly
                  placeholder={'End'}
                  format={"MMM DD YYYY"}
                  value={pws.end_date ? moment((new Date(pws.end_date)).toString()) : null}
                  disabledDate={(current) => current && current < (pws.start_date ? moment((new Date(pws.start_date)).toString()) : moment())}
                  onChange={(e) => this.onPWSStationChanged(card, inner_card, pws_index,'end_date', e)}
                />
                {errors?.[card_index]?.[inner_card_index]?.[`pws_installations[${pws_index}].end_date`] ? <label className="new_err_msg">
                  <i className="las la-info-circle"/>{errors?.[card_index]?.[inner_card_index]?.[`pws_installations[${pws_index}].end_date`]}</label> : ''}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  // render Inner cards
  renderInnerCard = (card, card_index, inner_card, inner_card_index) => {
    const {errors} = this.state;
    // let isValid = false;
    // map(inner_card?.pws_installations, (x) => {
    //   if (x.number_of_pws_stations && x.start_date && x.end_date) {isValid = true} else {
    //     isValid = false;
    //     return null
    //   }
    // })

    return (
      <Card key={`kanban${inner_card_index}`} className="kncard" draggable={"true"}
        onDragStart={(e) => this.onDragStart(e, card_index, inner_card_index)}>
        <div className="kncard-head flex">
          <div className='flex-1'><h6>{inner_card?.commercial_quote?.management_company}</h6></div>
          <span>:</span>
        </div>
        <span className="utility"> Miss Utility: Not defined </span>
        <span className="link" onClick={() => {
          // for multiple locations
          if (inner_card?.multiple_locations) {
            let locations = inner_card?.multiple_locations?.split('MULTIPOINT')[1]
            locations = locations?.trim().substr(1, locations.trim().length - 2)
            let temp = locations?.split(', '), _markers = []
            map(temp, (obj) => _markers.push({lat: obj.split(' ')[0], lng: obj.split(' ')[1]}))
            this.setState({markers: _markers})
          } else {this.setState({markers: []})}
          setTimeout(() => this.toggleMap(), 1000)
          ///-------------------------------
        }}> View PWS map </span>
        <hr />
        <h6>Installation Dates</h6>
        {
          map(orderBy(inner_card?.pws_installations, 'created_at', 'asc'), (pws, pws_index) => this.renderInstallation(card, card_index, inner_card, inner_card_index, pws, pws_index))
        }
        {errors?.[inner_card_index]?.[`pws_installations`] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.[inner_card_index]?.[`pws_installations`]}</label> : ''}

        <button key="update" className={`btn btn-warning full-btn mb-10`} onClick={() => this.validate(inner_card?.pws_installations, inner_card?.uuid, card_index, inner_card_index)}>Update</button>
        <div className="add-date" onClick={() => this.onAddDate(card, inner_card_index)}>
          <PlusCircleOutlined className="mr-2" />
          <p className="mb-0">Add Another Date</p>
        </div>
      </Card>
    )
  }

  // render main cards
  renderMainCard = (card, card_index) => {
    return (
      <Card
        key={`kanbanouter${card_index}`}
        className={`inner-kncard ${card.title === 'Current' ? 'current' : ''}`}
        onDragOver={(e) => {e.preventDefault(); console.log('Drag Over')}}
        onDrop={(e) => this.onDrop(e, card_index)}>
        <label>{`${card.title}(${card.data.length})`}</label>
        {
          map(orderBy(card?.data, 'created_at', 'asc'), (inner_card, inner_card_index) => this.renderInnerCard(card, card_index, inner_card, inner_card_index))
        }
      </Card>
    )
  }

  render() {
    const {main_card, loader, showMap, markers} = this.state;

    return (
      <div className="block-row">
        {loader && <Loader />}
        <div className="kanban-row">
          {map(main_card, this.renderMainCard)}
        </div>
        {showMap && <PreviewMap
          visible={showMap}
          handleCancel={() => this.toggleMap()}
          markers={markers}
        />}
      </div>
    )
  }
}

export default Kanban